import React from 'react'
import { useTraceabilityData } from './contexts/TraceabilityDataContext';

const QualityAssurance= () => {
     const qualityData = [
    { label: "Fat %", value: "99.9%" },
    { label: "Moisture %", value: "0.3%" },
    { label: "FFA% (As Oleic Acid)", value: "0.5%" },
    { label: "BR Reading at 40°C", value: "41" },
    { label: "RM Value", value: "28" },
    { label: "Total Farmers", value: "44" },
    { label: "Total Milk Collected", value: "346 L" }
  ];
     const {brandData}= useTraceabilityData()
      const brandName = brandData?.logo?.brandName;
  return (
    <div> <div className="wrapper2">
        <br />
        <h2 className="heading2" style={{ textAlign: "center" }}>Quality Assurance at {brandName}</h2>
        <div className="underline2 my-3 mx-1"></div>
      </div>

      {/* Quality Tests */}
       <div className="bg-white py-8">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-2 gap-3 max-w-md mx-auto">
              {qualityData.map((item, index) => (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-green-500 to-green-700 rounded-xl p-3 text-white shadow-lg"
                >
                  <div className="text-xs text-green-50 mb-1">
                    {item.label}
                  </div>
                  <div className="text-2xl font-bold">{item.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
</div>
  )
}

export default QualityAssurance